import * as React from 'react';
import { connect } from 'react-redux';

import { RootState, history } from '../store';
import { FormState } from '../reducers';
import {
  addFile,
  addValue,
  checkedPanel,
  copyValue,
  getForms,
  incrimentToSend,
  markAllVisited,
  markVisited,
  recal,
  setError,
  setSection,
  getRequest,
  sendRequest,
} from '../actions';
import { createApiClient } from '../services/ApiClient';
import MetaJSON from '../components/metajson';
import FormattedMessage from '../i18n/FormattedMessage';
import { confirmDialog } from 'primereact/confirmdialog';
import moment = require('moment');
// import { findGetParameter } from '../utils/native';

interface Props {
  schema: FormState;
  loaders: any;
  language: any;
  formTypes: any;
}

interface State {
  errorField: any;
  loader: boolean;
  func: (open) => void;
  anchorTo: {
    sectionId: string;
    controlId: string;
  };
  anchoredTo: {
    sectionId: string;
    controlId: string;
  };
}

interface Actions {
  getRequest: any;
  getForms: any;
  setSection: any;
  addValue: (id: string, value: any, refresh: boolean) => void;
  sendRequest: any;

  addFile: any;
  checkedPanel: (
    panelId: string,
    checked: boolean,
    error: any | undefined,
  ) => void;
  incrimentToSend: any;
  copyValue: any;
  recal: any;
  markVisited: (id: string) => void;
  setError: (id: string, error: any) => void;
  markAllVisited: () => void;
}

interface PropsConnect {
  router: any;
}

const api = createApiClient();

class FormPage extends React.Component<Props & Actions & PropsConnect, State> {
  constructor(props) {
    super(props);
    this.onRevoke = this.onRevoke.bind(this);
    this.onDraft = this.onDraft.bind(this);
    this.onSend = this.onSend.bind(this);
    this.getRequestTemplateFileUrl = this.getRequestTemplateFileUrl.bind(this);
  }

  componentDidMount(): void {
    const {
      schema,
      getRequest,
      router: {
        params: { id },
      },
    } = this.props;
    if ((!schema.request_meta || !schema.request_meta.id) && id !== 'create') {
      getRequest(id);
    }
  }

  componentDidUpdate(
    prevProps: Readonly<Props & Actions & PropsConnect>,
    prevState: Readonly<State>,
    prevContext: any,
  ): void {
    const {
      router: {
        params: { id },
      },
    } = this.props;
    const { schema } = this.props;
    if (id === 'create' && schema.id) {
      this.props.router.replace(`/residents/${schema.id}`);
    }
  }

  onRevoke() {
    this.props.getForms();
    this.goBack();
  }

  onDraft() {
    this.goBack();
  }

  onSend() {
    const {
      router: {
        params: { id },
      },
      sendRequest,
      schema: { values, forms, request_type_id },
    } = this.props;

    const prevForms = forms.filter(
      (form) =>
        form.request_type_id === request_type_id &&
        form.sent_date &&
        !form.is_completed,
    );
    if (prevForms.length > 0) {
      prevForms.sort((a, b) =>
        moment(a.sent_date).isAfter(moment(b.sent_date)) ? -1 : 1,
      );
    }
    const sent_date = prevForms[0] ? prevForms[0].sent_date : null;

    if (id && sent_date) {
      confirmDialog({
        message: `От Вашей организации уже получена заявка на такую же услугу ${moment(
          sent_date,
        ).format('DD.MM.YYYY')}. Вы уверены, что хотите отправить ещё одну?`,
        header: 'Подтвердите действие',
        accept: () => {
          sendRequest(id, values);
          this.goBack();
        },
        reject: () => {},
        acceptLabel: 'Да',
        rejectLabel: 'Нет',
      });
    } else if (id && !sent_date) {
      sendRequest(id, values);
      this.goBack();
    }
  }

  goBack() {
    this.props.router.push('/residents/');
  }

  getRequestTemplateFileUrl(id, name) {
    if (id == 'agreementTemplate') {
      return (
        '/residents/api/requests/' +
        this.props.schema.id +
        '/request_template_file/'
      );
    }
    return `/requests/${id}/file/${name}`;
  }

  render() {
    const {
      language,
      schema: { status, id, forms, request_type_id },
      loaders,
    } = this.props;
    const prevForms = forms
      ? forms.filter(
          (form) => form.request_type_id === request_type_id && form.sent_date,
        )
      : [];
    if (prevForms.length > 0) {
      prevForms.sort((a, b) =>
        moment(a.sent_date).isAfter(moment(b.sent_date)) ? -1 : 1,
      );
    }
    const sent_date = prevForms[0]
      ? moment(prevForms[0].sent_date).format('DD.MM.YYYY')
      : '';

    const initData = {
      ORN: this.props.schema.orn,
      companyShort:
        this.props.schema &&
        this.props.schema.companies &&
        this.props.schema.companies.filter(
          (comp) => comp.orn === this.props.schema.orn,
        )[0] &&
        this.props.schema.companies.filter(
          (comp) => comp.orn === this.props.schema.orn,
        )[0].name,
      companyFull:
        this.props.schema &&
        this.props.schema.companies &&
        this.props.schema.companies.filter(
          (comp) => comp.orn === this.props.schema.orn,
        )[0] &&
        this.props.schema.companies.filter(
          (comp) => comp.orn === this.props.schema.orn,
        )[0].name,
      projects:
        this.props.schema.projects.length > 0
          ? this.props.schema.projects.map((project, key) => ({
              value: { ru: project.name },
              key: project.crm_id,
              name: project.name,
              description: project.description_ru,
              ...project,
            }))
          : null,
    };

    // @ts-ignore
    return (
      <article>
        {this.props.schema &&
          this.props.schema[`full_request_type_name_${language}`] && (
            <h1 className="page-title">
              {this.props.schema[`full_request_type_name_${language}`]}
            </h1>
          )}
        <div className="form-info">
          <div className="form-info__item">
            <div className="form-info__item-label">
              <FormattedMessage id="request_number" />:
            </div>
            <div className="form-info__item-data">{id}</div>
          </div>
          <div className="form-info__item">
            <div className="form-info__item-label">
              <FormattedMessage id="request_status" />:
            </div>
            <div className="form-info__item-data uppercase">{status}</div>
          </div>
        </div>
        <MetaJSON
          schema={this.props.schema}
          loaders={loaders}
          noTitle={true}
          initData={initData}
          onRevoke={this.onRevoke}
          onDraft={this.onDraft}
          getForms={this.props.getForms}
          addValue={this.props.addValue}
          sendDocument={this.onSend}
          isRemovePanelBlock={api.isRemovePanelBlock}
          setFileValue={(options, value, fileId, handlers) =>
            api.setFileValue(
              { ...options, id: this.props.schema.id, field: options.id },
              value,
              fileId,
              handlers,
            )
          }
          deleteFileValue={(id, fileName, value, fileId, handlers) =>
            api.deleteFileValue(
              this.props.schema.id,
              fileName,
              value,
              id,
              handlers,
            )
          }
          getFileUrl={this.getRequestTemplateFileUrl}
          hasRemoveBlock={api.hasRemoveBlock}
          sendPDF={api.sendPDF}
          sendValues={api.sendValues}
          sendAdditional={api.sendAdditional}
          deleteValues={api.deleteValues}
          cloneRequest={api.cloneRequest}
          addFile={this.props.addFile}
          copyValue={this.props.copyValue}
          markVisited={this.props.markVisited}
          markAllVisited={this.props.markAllVisited}
          setSection={this.props.setSection}
          setError={this.props.setError}
          incrimentToSend={this.props.incrimentToSend}
          recal={this.props.recal}
        />
      </article>
    );
  }
}

const mapStateToProps = (state: RootState, ownProps: {}): Props => {
  return {
    schema: state.forms,
    loaders: state.forms.loaders,
    language: state.common.language,
    formTypes: state.forms.types,
  };
};

const mapDispatchToProps = (dispatch: any): Actions => {
  return {
    getForms: () => dispatch(getForms()),
    getRequest: (id) => dispatch(getRequest(id)),
    setSection: (id: string) => dispatch(setSection(id)),
    addValue: (id: string, value: any, refresh: boolean) =>
      dispatch(addValue(id, value, refresh)),
    sendRequest: (id: string, data: any) => dispatch(sendRequest(id, data)),

    addFile: (id: string, filename: string) => dispatch(addFile(id, filename)),
    checkedPanel: (panelId: string, checked: boolean, error: any | undefined) =>
      dispatch(checkedPanel(panelId, checked, error)),
    incrimentToSend: () => dispatch(incrimentToSend()),
    copyValue: (sourceId: string, targetId: string) =>
      dispatch(copyValue(sourceId, targetId)),
    recal: () => dispatch(recal()),
    markVisited: (id: string) => dispatch(markVisited(id)),
    setError: (id: string, error: any) => dispatch(setError(id, error)),
    markAllVisited: () => dispatch(markAllVisited()),
  };
};

export default connect<Props, Actions, {}>(
  mapStateToProps,
  mapDispatchToProps,
)(FormPage);
